import { render, staticRenderFns } from "./UsernameFiltered.vue?vue&type=template&id=fa8cb80a&"
import script from "./UsernameFiltered.vue?vue&type=script&lang=js&"
export * from "./UsernameFiltered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports